import { render, staticRenderFns } from "./job_data.vue?vue&type=template&id=476bb580&scoped=true"
import script from "./job_data.vue?vue&type=script&lang=js"
export * from "./job_data.vue?vue&type=script&lang=js"
import style0 from "./job_data.vue?vue&type=style&index=0&id=476bb580&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476bb580",
  null
  
)

export default component.exports